import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { Button } from '@piplapps/pipl-ui';
import LoadingButton from '../../../../Components/LoadingButton';
import { UsersActions } from '../../../../Redux/modules/users/actions';
import styles from './RemoveUserModal.module.less';
import AnalyticsEventNames from '../../../../Utils/AnalyticsHandler/AnalyticsEventNames';
import AnalyticsHandler from '../../../../Utils/AnalyticsHandler/AnalyticsHandler';

const RemoveUser = (props) => {
  const { userData } = props;
  const handleRemoveUser = useCallback(() => {
    props.onRemoveUser(userData.id);
  }, [userData]);

  return (
    <div className={styles.modalContainer}>
      <div className={styles.header} id="modal-title">
        {gettext('Remove user')}
      </div>
      <span
        tabIndex={0}
        role="button"
        className={styles.close}
        onClick={() => {
          props.clickedCloseModalButton();
        }}
      >
        &times;
      </span>
      <div className={styles.text}>
        {gettext('Are you sure you want to permanently remove the user ')}
        <strong>{gettext(` ${userData.first_name} ${userData.last_name} (${userData.email})`)}</strong>?
      </div>

      <div className={styles.buttonContainer}>
        <div className={styles.buttonUpdate}>
          <AnalyticsHandler
            eventName={AnalyticsEventNames.REMOVE_USER}
            eventData={{ manipulatedUser: userData.id, manipulatedUserEmail: userData.email }}
          >
            <LoadingButton
              buttonClass="primary-red"
              type="submit"
              onClick={handleRemoveUser}
              text={gettext('Remove user')}
              width="39%"
              loadingText={gettext('Removing')}
              id="submit-button"
            />
          </AnalyticsHandler>
        </div>
        <div className={styles.buttonCancel}>
          <Button
            buttonClass="secondary-blue"
            onClick={() => props.clickedCloseModalButton()}
            text={gettext('Cancel')}
            width="39%"
            id="cancel-button"
          />
        </div>
      </div>
    </div>
  );
};

RemoveUser.propTypes = {
  userData: PropTypes.object,
  onRemoveUser: PropTypes.func,
  clickedCloseModalButton: PropTypes.func,
};

const mapDispatchToProps = {
  onRemoveUser: UsersActions.removeUser,
  clickedCloseModalButton: UsersActions.clickedCloseModalButton,
};

export default connect(null, mapDispatchToProps)(RemoveUser);
